export default __webpack_public_path__ + "static/project-slide-5-2016-765-e29113de50928db713fefb2865c54fd6.webp";